module.exports = __webpack_public_path__ + "static/media/central_fans.80e06b85.png";